import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Drawer, Typography, Box, IconButton } from "@mui/material";
import MotionClose from "../../shared/Icons/MotionClose";
import EMPFilterSidebar from "../../shared/components/EMPFilterSidebar/EMPFilterSidebar";
import EMPButton from "../../shared/components/EMPButton/EMPButton";
import { UserContext } from "../../shared/context/userContext";

const FiltersDrawer = ({
  open,
  onClose,
  filters,
  selectedFilters,
  onFilterChange,
  onFilterClear,
  hideClear,
  isDisabled,
}) => {
  const { user } = useContext(UserContext) || {};
  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": {
          width: "min(390px, 100vw)",
          padding: 4,
          height: "100vh",
          overflow: "hidden",
        },
      }}
    >
      <Box textAlign="right">
        <IconButton
          onClick={onClose}
          data-testid="filters-drawer-close-button"
          aria-label="Close filters drawer"
        >
          <MotionClose />
        </IconButton>
      </Box>
      <Box
        role="presentation"
        sx={{
          overflowY: "auto",
          paddingBottom: 4,
          maxHeight: "calc(100vh - 64px)",
        }}
      >
        <Typography variant="h4" sx={{ mb: 6 }}>
          Filters
        </Typography>
        <EMPFilterSidebar
          filters={filters}
          selectedFilters={selectedFilters}
          onFilterChange={onFilterChange}
          onFilterClear={onFilterClear}
          hideClear={hideClear}
          disabled={isDisabled}
        />
        {user?.brand === "L" && (
          <Box mt={2}>
            <EMPButton
              variant="outlined"
              onClick={onFilterClear}
              disabled={
                isDisabled ||
                !Object.values(selectedFilters).some((values) => values.length)
              }
            >
              Remove All
            </EMPButton>
          </Box>
        )}
      </Box>
    </Drawer>
  );
};

FiltersDrawer.propTypes = {
  filters: PropTypes.object,
  isDisabled: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onFilterClear: PropTypes.func.isRequired,
  hideClear: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  selectedFilters: PropTypes.object,
};

FiltersDrawer.defaultProps = {
  filters: {},
  isDisabled: false,
  selectedFilters: {},
  hideClear: false,
};

export default FiltersDrawer;
